import {
    initMain
} from './vue/controllers/main';


initMain([], {
    BillingForm: () => import('./vue/components/billing-form/BillingForm.vue')
});